"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMultiLineFilter = exports.getFilterValueExpression = void 0;
const dbgate_tools_1 = require("dbgate-tools");
const moment_1 = __importDefault(require("moment"));
function getFilterValueExpression(value, dataType) {
    if (value == null)
        return 'NULL';
    if ((0, dbgate_tools_1.isTypeDateTime)(dataType))
        return (0, moment_1.default)(value).format('YYYY-MM-DD HH:mm:ss');
    if (value === true)
        return 'TRUE';
    if (value === false)
        return 'FALSE';
    if (value.$oid)
        return `ObjectId("${value.$oid}")`;
    return `="${value}"`;
}
exports.getFilterValueExpression = getFilterValueExpression;
function createMultiLineFilter(mode, text) {
    let res = '';
    for (let line of text.split('\n')) {
        line = line.trim();
        if (line.length == 0)
            continue;
        if (res.length > 0) {
            switch (mode) {
                case 'is_not':
                    res += ' ';
                    break;
                default:
                    res += ',';
                    break;
            }
        }
        switch (mode) {
            case 'is':
                res += "='" + line + "'";
                break;
            case 'is_not':
                res += "<>'" + line + "'";
                break;
            case 'contains':
                res += "'" + line + "'";
                break;
            case 'begins':
                res += "^'" + line + "'";
                break;
            case 'ends':
                res += "$'" + line + "'";
                break;
        }
    }
    return res;
}
exports.createMultiLineFilter = createMultiLineFilter;
